import { useEffect } from 'react'
import { FieldValues, useFormContext, useFormState } from 'react-hook-form'

type OnSubmit = (data: FieldValues) => Promise<void>

// In a rare case async validation can get stuck in isValidating / isSubmitting state.
// If that is the case, after the timeout try to reset the from state and submit again to unstuck the validation
export const ValidationReSubmitFallback = <T extends FieldValues>({ onSubmit }: { onSubmit: (data: T) => unknown }) => {
  const { isSubmitting } = useFormState()
  const { reset, handleSubmit } = useFormContext()
  useEffect(() => {
    const VALIDATION_TIMEOUT = 10_000
    if (isSubmitting) {
      const id = setTimeout(() => {
        reset(undefined, { keepValues: true, keepIsValidating: false })
        void handleSubmit(onSubmit as OnSubmit)()
      }, VALIDATION_TIMEOUT)

      return () => clearTimeout(id)
    }
  }, [isSubmitting, reset, onSubmit, handleSubmit])
  return null
}
